module.exports = __webpack_public_path__ + "img/5.48c80109.png";